var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-navbar',{staticClass:"navbar-custon",attrs:{"toggleable":"md","type":"light","variant":"light"}},[_c('div',{staticClass:"cards"},[_vm._t("menuAdm"),_c('div',{staticClass:"shadow-sm px-5"},[_vm._t("menu")],2)],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }